import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import useLogout from "../login/Logout";
import { getSenderName, formatMailDate } from "../../utils/emailTools";
const { confirm } = Modal;

const MasterLayout = ({ children }) => {
  const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
  const { unreadCount, emails } = useSelector((state) => state.mail) || { unreadCount: 0, emails: [] };
  const profile = useSelector((state) => state.profile.profile) || null;
  const location = useLocation();
  const navigate = useNavigate();
  const logout = useLogout();
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);

  // notification
  const [notificationData, setNotificationData] = useState([]);
  const [notificationUnreadCount, setNotificationUnreadCount] = useState(null);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const limit = 10;
  const hasMoreRef = useRef(hasMore);
  const loadingRef = useRef(loading);
  const isReportActive = location.pathname === "/reports";


  // menus 
  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");
      if (!clickedDropdown) return;
      const isActive = clickedDropdown.classList.contains("open");
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px";
        }
      });
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`;
        }
      }
    };
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );
    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            }
          }
        });
      });
    };
    openActiveDropdown();
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);

  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const handleMobileLinkClick = () => {
    if (mobileMenu) setMobileMenu(false);
  };


  const LogoutConfirm = () => {
    confirm({
      title: "Are you sure you want to logout?",
      width: 400,
      height: 400,
      okText: "Yes, Logout",
      okType: "danger",
      cancelText: "Cancel",
      centered: true,
      okButtonProps: {
        className: "custom-modal-btn custom-delete-btn",
      },
      cancelButtonProps: {
        className: "custom-modal-btn custom-cancel-btn",
      },
      onOk() { logout() },
    });
  };

  console.log("viewPermission ===> ", viewPermissions);

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <div className='sidebar-logo'>
            <img
              src='/assets/images/sidebar.png'
              alt='site logo'
              className=' light-logo'
            />
          </div>
        </div>
        <div className='sidebar-menu-area'>

          {/* ----------------- sidebar with permissions---------------- */}
          <ul className="sidebar-menu" id="sidebar-menu">

            {viewPermissions.includes("dashboard.view") && (
              <li>
                <NavLink
                  to="/dashboard"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
                  <span>Dashboard</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("event.view") && (
              <li>
                <NavLink
                  to="/events"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:calendar-star" className="menu-icon" />
                  <span>Events</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("church.view") && (
              <li>
                <NavLink
                  to="/churches"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:church" className="menu-icon" />
                  <span>Churches</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("lead.view") && (
              <li>
                <NavLink
                  to='/leads'
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:leads" className="menu-icon" />
                  <span>Leads</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("reader.view") && (
              <li>
                <NavLink
                  to="/readingplan"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:book-open-page-variant" className="menu-icon" />
                  <span>Reading Plan</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("bookmark.view") && (
              <li>
                <NavLink
                  to="/bookmark"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:bookmark" className="menu-icon" />
                  <span>Bookmarks</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("notes.view") && (
              <li>
                <NavLink
                  to="/notes"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:notes" className="menu-icon" />
                  <span>Notes</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("notes.view") && (
              <li>
                <NavLink
                  to="/articles"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="tabler:article" className="menu-icon" />
                  <span>Articles</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("notes.view") && (
              <li>
                <NavLink
                  to="/prayer-request"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="tabler:pray" className="menu-icon" />
                  <span>Prayer Request</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("remainders.view") && (
              <li>
                <NavLink
                  to="/remainders"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:alarm" className="menu-icon" />
                  <span>Remainders</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("notification.view") && (
              <li>
                <NavLink
                  to="/notification"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:bell" className="menu-icon" />
                  <span>Notifications</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("mobile.view") && (
              <li>
                <NavLink
                  to="/mobile-users"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:account-outline" className="menu-icon" />
                  <span>Users</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("subscriber.view") && (
              <li>
                <NavLink
                  to="/subscribers"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:crown-outline" className="menu-icon" />
                  <span>Pro Subscribers</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("mobile.view") && (
              <li>
                <NavLink
                  to="/image-upload"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:image" className="menu-icon" />
                  <span>Image Verse</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("user.view") && (
              <li>
                <NavLink
                  to="/users"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="mdi:face-agent" className="menu-icon" />
                  <span>Customers</span>
                </NavLink>
              </li>
            )}

            {viewPermissions.includes("role.view") && (
              <li>
                <NavLink
                  to="/roles"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                  onClick={handleMobileLinkClick}
                >
                  <Icon icon="ri-user-settings-line" className="menu-icon" />
                  <span>Role &amp; Access</span>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        {/* Header */}
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>

              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>

                {/* Message */}
                <div className="dropdown">
                  <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Icon icon="mage:email" className="text-primary-light text-xl" />
                    {unreadCount > 0 && (
                      <span className="icon-count">{unreadCount}</span>
                    )}
                  </button>

                  <div className="dropdown-menu to-top dropdown-menu-end dropdown-menu-lg p-0">
                    <div className='m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-0'>
                          Message
                        </h6>
                      </div>
                    </div>
                    <div className='max-h-400-px overflow-y-auto scroll-sm pe-4'>
                      {emails.length === 0 && (
                        <p className="text-center text-secondary-light py-12">
                          No new messages
                        </p>
                      )}
                      {emails.map((mail) => (
                        <Link
                          key={mail.id}
                          to={`/email/${mail.id}`}
                          className='px-24 py-12  d-flex align-items-start gap-3 mb-2 justify-content-between'
                        >
                          <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>

                            <div>
                              <h6 className={`text-md fw-semibold mb-4 ${mail.is_read ? "title-read" : ""}`}>
                                {getSenderName(mail.mail_from)}
                              </h6>
                              <p className={`mb-0 text-sm text-w-235-px ${mail.is_read ? "message-read" : "text-secondary-light"}`}>
                                {mail.subject}
                              </p>
                            </div>
                          </div>

                          <div className='d-flex flex-column align-items-end'>
                            <span className={`text-sm text-w-235-px flex-shrink-0 ${mail.is_read ? "title-read" : "text-secondary-light"}`}>
                              {formatMailDate(mail.mail_date)}
                            </span>

                            {!mail.is_read && (
                              <span className='mt-4 text-xs text-base w-16-px h-16-px d-flex justify-content-center align-items-center bg-warning-main rounded-circle'>
                                !
                              </span>
                            )}
                          </div>
                        </Link>
                      ))}
                    </div>

                    <div className='text-center py-12 px-16'>
                      <Link
                        to='/email'
                        className='text-primary-600 fw-semibold text-md'
                      >
                        See All Message
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Profile */}
                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    {profile.icon ?
                      (<img
                        src={`${API.IMAGE_BASE_URL}/${profile.icon}`}
                        alt='image_user'
                        className='w-40-px h-40-px object-fit-cover rounded-circle'>
                      </img>) : (<img
                        src='assets/images/logo-profile.png'
                        alt='image_user'
                        className='w-40-px h-40-px object-fit-cover rounded-circle'
                      />)}
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                          {profile?.name}
                        </h6>
                        <span className='text-secondary-light fw-medium text-sm'>
                          {profile?.email}
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/myprofile'
                        >
                          <Icon
                            icon='solar:user-linear'
                            className='icon text-xl'
                          />{" "}
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                          to='/settings'
                        >
                          <Icon
                            icon='icon-park-outline:setting-two'
                            className='icon text-xl'
                          />
                          Settings
                        </Link>
                      </li>
                      <li>
                        <button
                          onClick={LogoutConfirm}
                          style={{
                            background: "none",
                            border: "none",
                            outline: "none",
                            color: "inherit",
                            fontSize: "15px",
                            fontWeight: "500",
                            width: "100%",
                            textAlign: "left",
                            padding: "9px 0px",
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            cursor: "pointer",
                            borderRadius: "8px",
                            lineHeight: "1.5",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f4f6ff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "none";
                          }}
                        >
                          <Icon
                            icon="lucide:power"
                            className="menu-icon"
                            style={{ fontSize: "20px", fontWeight: "800" }}
                          />
                          <span style={{ marginLeft: "5px", fontWeight: "500" }}>Logout</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* All Main Components */}
        <div className='dashboard-main-body'>{children}</div>

        {/* Footer */}
        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© {new Date().getFullYear()} Wipnttech. All Rights Reserved.</p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;